<template>
    <div>
        <v-dialog
                v-model="showLogin"
                max-width="600px"
                :persistent="persistentLogin"

        >

            <v-card flat>
                <v-toolbar
                        flat
                        dark
                        color="primary "
                >
                    <v-layout wrap align-center>
                        <v-flex xs6 text-xs-left>
                            <p class="headline font-weight-regular mb-3 mt-4">Ingresar</p>
                        </v-flex>
                    </v-layout>
                </v-toolbar>
                <div class="loading-container">
                    <v-progress-linear
                            v-show="loadingLogin"
                            height="2"
                            :indeterminate="true"
                            class="ma-0"
                    ></v-progress-linear>
                </div>
            </v-card>

            <v-sheet color="white darken-3 pb-2 pl-4 pr-4 pt-4">

                <v-layout justify-center>
                    <v-flex sm12 md11 xl10>

                        <v-form
                                v-model="valid"
                                row
                                justify-center>

                            <v-text-field
                                    @keyup.enter="login"
                                    v-model="email"
                                    :rules="emailRules"
                                    label="E-mail"
                                    required
                            ></v-text-field>

                            <v-text-field
                                    @keyup.enter="login"
                                    v-model="password"
                                    :rules="passwordRules"
                                    label="Contraseña"
                                    type="password"
                                    class="mt-2 mb-3"
                                    required
                            ></v-text-field>

                            <v-flex sm12 class="text-xs-right mb-3">
                                <v-btn

                                        color="transparent"
                                        depressed
                                        :disabled="disabled"
                                        @click="showReset"
                                        class="mr-1 float-left">
                                    Recuperar contraseña
                                </v-btn>
                                <v-btn v-if="persistentLogin"  color="primary" @click="closeLogin" flat class="mr-0">Cancelar</v-btn>
                                <v-btn :dark="valid && !disabled" color="primary" :disabled="!valid || disabled" @click="login" class="mr-0">Ingresar</v-btn>
                            </v-flex>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-sheet>
        </v-dialog>



        <v-dialog
                v-model="showLogout"
                max-width="500px"
        >

            <v-card flat>
                <v-toolbar
                        flat
                        dark
                        color="primary "
                >
                    <v-layout wrap align-center>
                        <v-flex xs6 text-xs-left>
                            <p class="headline font-weight-regular mb-3 mt-4">Cerrar sesión</p>
                        </v-flex>
                    </v-layout>
                </v-toolbar>

            </v-card>

            <v-sheet color="white darken-3 pb-2 pl-4 pr-4">
                <v-layout justify-center align-center>
                    <v-flex sm12 xl10 >
                        <p class="pt-3 pb-3 subheading">¿Salir de la cuenta actual?</p>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-flex sm12 class="text-xs-right mb-3">
                        <v-btn color="primary" @click="setLogoutVisibility(false)" flat class="mr-0">Cancelar</v-btn>
                        <v-btn depressed dark color="primary" @click="logout" class="mr-0">Sí, deseo salir.</v-btn>
                    </v-flex>
                </v-layout>
            </v-sheet>
        </v-dialog>

        <kimsa-password-reset ref="resetDialog"/>

    </div>

</template>

<script>

    import { mapState, mapMutations } from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    import KimsaPasswordReset from '@/components/common/KimsaPasswordReset'

    export default{
        name: 'LoginDialog',
        props: ['onLoginSuccess'],
        components: {KimsaPasswordReset},
        data(){
            return {
                valid: false,
                disabled: false,
                resetDialog: null,
                email: '',
                password: '',
                emailRules: [
                    v => !!v || 'E-mail es obligatorio',
                    v => /.+@.+/.test(v) || 'E-mail inválido'
                ],
                passwordRules: [
                    v => !!v || 'Contraseña es obligatoria',
                    v => v.length >= 6 || 'Debe tener al menos 6 caracteres'
                ],
            }
        },
        computed: {
            showLogin: {
                get(){
                    return this.$store.state.showLogin
                },
                set(newValue){
                    if(newValue == true){
                        this.$store.commit('openLoginForm')
                    }else{
                        this.$store.commit('closeLoginForm')
                    }
                }
            },
            showLogout: {
                get(){
                    return this.$store.state.showLogout
                },
                set(newValue){
                    this.setLogoutVisibility(newValue)
                }
            },
            ...mapState(['persistentLogin', 'currentUser', 'loginMessage', 'loadingLogin'])
        },
        methods: {
            ...mapMutations(['closeLoginForm', 'showSnackBar', 'setLogoutVisibility', 'setLoginLoading']),
            showReset(){
                this.$refs.resetDialog.show()
            },
            async facebookSuccess(authResponse){
                var vm = this
                vm.disabled = true

                const loginResponse = await ApiUtils.loginWithSocial(authResponse.accessToken)
                if(loginResponse.code != 200){
                    const json = await loginResponse.json()
                    vm.$emit('error', json)
                    vm.disabled = false
                    return
                }

                vm.disabled = false

                vm.closeLoginForm()
                if(typeof vm.onLoginSuccess == 'function'){
                    vm.onLoginSuccess(authResponse)
                }
            },
            async facebookError(){
                var vm = this
                vm.showSnackBar('Ocurrio un error intentando ingresar', 'secondary')
            },
            async login(){

                var vm = this
                vm.disabled = true
                const response = await ApiUtils.login(vm.email, vm.password, true)
                vm.disabled = false

                if(response.code == 401){
                    vm.showSnackBar('Usuario y/o password incorrecto(s)', 'secondary')
                    return
                }

                vm.closeLoginForm()
                if(typeof vm.onLoginSuccess == 'function'){
                    vm.onLoginSuccess(response)
                }
            },
            closeLogin(){
                var vm = this
                vm.disabled = false
                vm.closeLoginForm()
                if(vm.loadingLogin === true){
                    vm.setLoginLoading(false)
                    vm.setCurrentUser(null)
                }
            },
            async logout(){
                await ApiUtils.logout()
                this.setLogoutVisibility(false)
            }
        }
    }
</script>

<style scoped>
    .loading-container{
        padding: 0;
        height: 2px;
        width: 100%;
    }
</style>